import { useRef, useEffect, useState } from "react";
import "../BuiltToGrow.css";
import girl_pen_on_battery from "../../../assets/girl_pen_on_battery.png";
import icon_tick from "../../../assets/icon_tick.png";
import builtBg from "../../../assets/built_bg_luxury_home.jpg";

export default function BuiltToGrow() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.2 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={sectionRef}
      className={`built-proven-brands-section ${inView ? "built-in-view" : ""}`}
      style={{ backgroundImage: `url(${builtBg})` }}
    >
      <div className="built-bg-overlay" />
  <div className="built-proven-brands-section-inner">
    <div className="built-brands-content">

      {/* LEFT */}
      <div className="built-brands-info-card">
        <h2>Built to Grow with Your Home</h2>

        <div className="built-feature-row">
          <img src={icon_tick} alt="icon" className="built-feature-icon" />
          <p className="built-info-footer-list">
            With Alpha ESS <span className="built-highlight">operating in Australia for over 10 years</span>,
            consistently ranking <span className="built-highlight">Top 5 by market share</span> and achieving
            <span className="built-highlight"> No.1 position in 2023</span>.
          </p>
        </div>

        <div className="built-feature-row">
          <img src={icon_tick} alt="icon" className="built-feature-icon" />
          <p className="built-info-footer-list">
            A dedicated Australian after-sales team supports the system’s
            <span className="built-highlight"> 10-year manufacturer warranty</span>,
            delivering long-term reliability and peace of mind.
          </p>
        </div>

        <div className="built-feature-row">
          <img src={icon_tick} alt="icon" className="built-feature-icon" />
          <p className="built-info-footer-list">
            The platform is <span className="built-highlight">VPP-ready</span>
            and supports fast grid response, helping future-proof your investment.
          </p>
        </div>
      </div>

      {/* RIGHT */}
      <div className="built-brands-image-container">
        <img
          src={girl_pen_on_battery}
          alt="Modern home with solar battery system"
          className="built-brands-image"
        />
      </div>

    </div>
  </div>
</div>


  );
}
